<template>
	<div
		:id="`borger-micro-article-${_uid}`"
		:class="[
			'c-block-list-borger-micro-article-custom',
			'w-5col >=768:w-6col max-w-full mx-auto',
		]"
	>
		<BaseH2 v-if="title" class="text-primary-button mb-sm" v-text="title" />

		<div v-if="content" class="s-rich-text w-full" v-html="content"></div>
	</div>
</template>

<script>
export default {
	name: 'BlockListBorgerMicroArticleCustom',

	inheritAttrs: false,

	props: {
		content: String,
		id: String,
		title: String,
	},
};
</script>
